import { faCirclePause, faCirclePlay } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import { IconButton, type IconButtonProps } from "@aviary/components/Button/IconButton";
import type { EmblaCarouselType } from "@aviary/components/NewCarousel/emblaCarouselTypes";
import { l } from "@aviary/locales/i18n";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import { useAutoplay } from "../../useAutoplay";

import * as styles from "./PlayPauseButton.styles";

interface Props extends Omit<IconButtonProps, "aria-label"> {
  emblaApi: EmblaCarouselType;
}

const PlayPauseButton = ({ emblaApi, ...rest }: Props) => {
  const { t } = useTranslation();

  const { toggleAutoplay, isPlaying } = useAutoplay(emblaApi);

  const renderIcon = isPlaying ? faCirclePause : faCirclePlay;
  const renderAriaLabel = isPlaying ? l.aviary.carousel.stop : l.aviary.carousel.start;

  return (
    <IconButton
      intention="textSystem"
      size="small"
      onClick={toggleAutoplay}
      aria-label={t(renderAriaLabel)}
      css={styles.button}
      {...rest}
    >
      <FontAwesomeIcon icon={renderIcon} />
    </IconButton>
  );
};

export { PlayPauseButton };
